<div class="card-header d-flex jcsb">
  <span class="d-flex aic gap-05">
      <mat-icon fontSet="material-symbols-outlined">local_shipping</mat-icon>
  <strong>Tour {{ time() }} / {{ suffix() }}</strong>
  <span class="date">{{ date() | date: 'd.M.yyyy' }}</span>
    @if (updatedAt(); as updated) {
      <span class="updated">Zuletzt aktualisiert: {{ updated | date: 'dd.MM.yy, HH:mm' }} Uhr</span>
    }
  </span>
  <span class="status {{ status() }}">{{ statusLabel() }}</span>
</div>

<div class="card-columns">
  <section>
    <div class="card-subtitle">
      <mat-icon fontSet="material-symbols-outlined" class="icon">description</mat-icon>
      <strong>Belegnummern</strong>
    </div>
    @for (doc of documents(); track doc.no) {
      <p>
        <button type="button" class="link" (click)="download.emit(doc.no)">
          {{ doc.no }}
          <mat-icon fontSet="material-symbols-outlined">download</mat-icon>
        </button>
        <br>
        <small>{{ doc.label }} · {{ doc.lines.length }} Artikel</small>
      </p>
    }
  </section>

  <section>
    <div class="card-subtitle">
      <mat-icon fontSet="material-symbols-outlined" class="icon">inventory_2</mat-icon>
      <strong>Inhalt</strong>
    </div>
    <p>
      Packungen: {{ packages() }}<br>
      Positionen: {{ positions() }}
    </p>
    <button mat-stroked-button type="button" (click)="details.emit(tour())">
      <mat-icon fontSet="material-symbols-outlined">search</mat-icon>
      Details
    </button>
  </section>

  <section>
    <div class="card-subtitle">
      <mat-icon fontSet="material-symbols-outlined" class="icon">schedule</mat-icon>
      <strong>{{ status() === 'onTheWay' ? 'Voraussichtliche Ankunft' : 'Ankunft' }}</strong>
    </div>
    @if (arrival(); as at) {
      <div class="time {{ delayClass() }}">{{ at | date: 'HH:mm' }}</div>
      <div class="{{ delayClass() }}">{{ delayText() }}</div>
    } @else {
      <em>Noch nicht bekannt</em>
    }
  </section>
</div>
